import React from "react";
import CropOriginalIcon from "@material-ui/icons/CropOriginal";
const EmptyIcon = () => {
    return <div className="empty-icons">
    <CropOriginalIcon />
    <br />
    Empty
  </div>
  };
  export default EmptyIcon;